module.exports = __webpack_public_path__ + "static/media/gamification.6bd4876a.mp4";